import * as React from "react";

const DemoIcon = (props) => (
  <svg
    version="1.1"
    viewBox="0 0 32 32"
    width={24}
    height={24}
    fill={props.fill ?? "#000000"}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        class="bentblocks_een"
        d="M4,10h6V4H4V10z M6,6h2v2H6V6z M28,6v2H14V6H28z M4,19h6v-6H4V19z M6,15h2v2H6V15z M14,15h14v2H14 V15z M4,28h6v-6H4V28z M6,24h2v2H6V24z M14,24h14v2H14V24z"
      ></path>
    </g>
  </svg>
);

export default DemoIcon;
